import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import axios from "axios"
import { apiURL } from "@/configs/serverConfig";
import i18n from '@/js/i18n';
import Cookies from "js-cookie";

Vue.use(VueRouter);

function checkToken() {
  return store.state.token.length > 0;
}

function checkAccessFrom() {
  return store.state.access_from;
}

const routes = [
  {
    path: "/",
    name: "Signin",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/LoginWithSSOView.vue"),
    meta: {
      layout: "emptyLayout",
    },
  },
  {
    path: "/callback",
    name: "Callback",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CallbackView.vue"),
    meta: {
      layout: "emptyLayout",
    },
  },
  {
    path: "/main",
    name: "MainMobileView",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/MainMobileView.vue"),
    meta: {
      layout: "AppLayoutMobile",
    },
    beforeEnter: async (to, from, next) => {
      if (checkAccessFrom() === 'measure_qr_code') {
        console.log('checkAccessFrom',checkAccessFrom())
        next('/not-support');
      } else if (checkToken()) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: "/buildings",
    name: "Create Building",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/BuildingView.vue"),
    meta: {
      layout: "AppLayoutMobile",
    },
    beforeEnter: async (to, from, next) => {
      if (checkAccessFrom() === 'measure_qr_code') {
        next('/not-support');
      } else if (checkToken()) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: "/fillin-daily/:id",
    name: "กรอกข้อมูล",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/FillInDailyView.vue"),
    meta: {
      layout: "AppLayoutMobile",
    },
    beforeEnter: async (to, from, next) => {
      if (checkAccessFrom() === 'measure_qr_code') {
        next('/not-support');
      } else if (checkToken()) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: "/detail-daily/:location_id/:id",
    name: "Detail Daily",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/DetailDailyView.vue"),
    meta: {
      layout: "AppLayoutMobile",
    },
    beforeEnter: async (to, from, next) => {
      if (checkAccessFrom() === 'measure_qr_code') {
        next('/not-support');
      } else if (checkToken()) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: "/register-code",
    name: "Register Code",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/RegisterMobileCode.vue"),
    // meta: {
    //   layout: "AppLayoutMobile",
    // },
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/RegisterMobile.vue"),
    meta: {
      layout: "emptyLayout",
    },
  },
  {
    path: "/book-demo",
    name: "Book Demo",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/BookDemo.vue"),
    meta: {
      layout: "AppLayoutMobile",
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ProfileView.vue"),
    meta: {
      layout: "AppLayoutMobile",
    },
    beforeEnter: async (to, from, next) => {
      if (checkToken() == true) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/thankyou",
    name: "Thankyou",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ThankForBookDemo.vue"),
  },
  {
    path: "/verify",
    name: "VerifyAccount",
    component: () => import("@/views/VerifyView.vue"),
    props: (route) => ({
      email: route.query.email,
      code: route.query.code,
    }),
  },
  {
    path: "/not-support",
    name: "Not Support",
    component: () => import("@/views/BrowserNotSupport.vue"),
    meta: {
      layout: "emptyLayout",
    },
  },
  {
    path: "/waste-management",
    name: "WasteMeasurementDetail",
    component: () => import("@/views/waste/MeasurementDetail.vue"),
    meta: {
      layout: "AppLayoutMobile",
    },
    beforeEnter: async (to, from, next) => {
      let keyData = to.query?.key;
      if(!keyData) {
        return next('/not-support');
      }
      

      let checkKey = localStorage.getItem("keyWaste");
      const now = new Date().getTime();
      const parsed = JSON.parse(checkKey);
      if (checkKey && now > parsed.expire) {
        localStorage.removeItem("keyWaste");
      }

      let localKey = localStorage.getItem("keyWaste");

      if(localKey == null) {
        const url = `${apiURL}/measure/qr_code/verify` 
        const _data = {
          key : keyData
        }
        try {
          const verifyKey = await axios.post(url,_data);
          if(verifyKey) {
            store.dispatch("setToken",verifyKey.data?.access_token);
            store.dispatch("setAccessFrom",verifyKey.data?.access_from);
            store.dispatch("waste/setMeasureListId",verifyKey.data?.measure_list_id);
            // set lang for user
            i18n.locale = "en";
            store.dispatch("selectLang/setLanguage", "en");
            Cookies.set("user_lang", "en");
            const now = new Date().getTime(); // timestamp ปัจจุบัน
            const expireTime = now + 8 * 60 * 60 * 1000; // อีก 8 ชั่วโมง (ms)

            const dataWithExpire = {
              value: keyData,
              expire: expireTime
            };

            localStorage.setItem("keyWaste", JSON.stringify(dataWithExpire));
            // localStorage.setItem("keyWaste", keyData);
            next();
          }
        } catch(err) {
          console.log(err)
          next('/not-support');
        }
      }

      if (checkToken()) {
        next();
      } else {
        next("/");
      }
    }
  },
  
  // {
  //   path: "/daily-chart",
  //   name: "Daily Chart",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/DailyChartView.vue"),
  //   meta: {
  //     layout: 'AppLayoutMobile'
  //   },
  //   beforeEnter : async (to, from, next) => {
  //     if(checkToken() == true) {
  //       next()
  //     } else {
  //       next('/');
  //     }
  //   }
  // },
];

const router = new VueRouter({
  mode: "history",
  routes: routes,
});

router.beforeEach(async (to, from, next) => {
  if (checkToken() == true) {
    next();
  } else {
    if (
      to.name == "Signin" ||
      to.name == "Register Code" ||
      to.name == "Register" ||
      to.name == "Book Demo" ||
      to.name == "Thankyou" ||
      to.name == "VerifyAccount" ||
      to.name == "Not Support" ||
      to.name == "WasteMeasurementDetail" || 
      to.name == "Callback"
    ) {
      next();
    } else {
      next("/");
    }
  }
});

export default router;
